import { Button, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signup } from "../../actions/auth";
import {
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";

const Register = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [form] = Form.useForm();
  const [, forceUpdate] = useState({});

  const [loading, setLoading] = useState(false);

  const onFinish = (value) => {
    setLoading(true);
    let formData = {
      ...value,
      role: "ADMIN",
    };
    dispatch(signup(formData, history, setLoading));
  };

  useEffect(() => {
    setLoading(false);
    forceUpdate({});
  }, []);

  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center bg-gray-100">
      <p>Sign up first to create a new store.</p>
      <Form
        form={form}
        name="basic"
        style={{ width: 300 }}
        onFinish={onFinish}
        requiredMark={false}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please input your email!" }]}
        >
          <Input prefix={<MailOutlined className="site-form-item-icon" />} />
        </Form.Item>
        <Form.Item
          label="Phone"
          name="phone"
          rules={[{ required: true, message: "Please input your phone!" }]}
        >
          <Input
            type="number"
            prefix={<PhoneOutlined className="site-form-item-icon" />}
          />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
          />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                !form.isFieldsTouched(true) ||
                !!form.getFieldsError().filter(({ errors }) => errors.length)
                  .length
              }
              loading={loading}
            >
              Sign up
            </Button>
          )}
        </Form.Item>
      </Form>
      <p>Already have an account for store?</p>
      <Button type="primary" href="/">
        Login
      </Button>
    </div>
  );
};

export default Register;
